import { Button } from "@suraasa/placebo-ui"
import { useExcludeDivider } from "components/Navigation/hooks/useExcludeDivider"
import PageContainer from "components/PageContainer"
import { AuthManager } from "features/Authentication/AuthManager"
import { Link } from "react-router-dom"
import routes from "routes"

type Props = {
  showSignInButton?: boolean
}

const WithoutAuth = ({ showSignInButton = true }: Props) => {
  const omitShadow = useExcludeDivider()

  return (
    <nav
      id="topNavbar"
      className="sticky top-0 z-navbar border-b border-surface-200 bg-white"
      style={{
        boxShadow: omitShadow ? "initial" : "1px 1px 5px rgba(0, 0, 0, 0.1)",
      }}
    >
      <PageContainer>
        <div className="flex items-center justify-between py-0.75">
          <Link to={routes.home}>
            <img
              src="https://assets.suraasa.com/logos/v2/mini.webp"
              alt="suraasa logo"
              width={40}
              height={40}
            />
          </Link>

          {showSignInButton && (
            <div>
              <Button
                onClick={() => AuthManager.redirectToLogin()}
                variant="text"
              >
                Sign In
              </Button>
            </div>
          )}
        </div>
      </PageContainer>
    </nav>
  )
}

export default WithoutAuth
